import React from 'react'
import propTypes from 'prop-types'
import classNames from 'classnames'
import { useHistory } from 'react-router'

import blankprofile from 'assets/blankprofile.png'
import { FaPen } from 'react-icons/fa'


export const AvatarImage = props => {
  const user = props.user
  const history = useHistory()

  return (
    <div className={classNames([
      props.className,
      'relative inline-block rounded-full shadow-lg activeDefault-2 transition-all',
      {
        'w-8 h-8 lg:w-12 lg:h-12': props.size === 'xsmall',
        'w-16 h-16 lg:w-24 lg:h-24': !props.size || props.size === 'small',
        'w-24 h-24 lg:w-32 lg:h-32': props.size === 'medium',
        'w-32 h-32 lg:w-40 lg:h-40': props.size === 'big',
        'border-2 border-primary-600': props.active,
        'border-2 border-disabled-400 hover:border-primary-600': ! props.active && props.hover,
      }
    ])}>
      {
        props.edit &&
        <FaPen
          className='
            cursor-pointer
            opacity-100 lg:opacity-0 group-hover:opacity-100
            absolute
            right-0
            bottom-0
            transition-all
            bg-disabled-500 text-white
            hover:bg-primary-600
            rounded-full
            text-4xl
            p-2
          '
          onClick={() => history.push('/account/profile')}
        />
      }
      <img
        alt={user.fullName}
        src={user.profilePic?.thumbnail || blankprofile}
        className='object-cover w-full h-full bg-white rounded-full'
      />
    </div>
  )
}


AvatarImage.propTypes = {
  user: propTypes.object.isRequired,
  size: propTypes.string,
  className: propTypes.string,
  active: propTypes.bool,
  hover: propTypes.bool,
}


export default function Avatar(props) {
  const user = props.user
  const history = useHistory()

  const className = classNames([
    props.className,
    'flex relative group',
    {
      'flex-col items-center': ! props.horizontal,
      'flex-row items-center space-x-6': props.horizontal,
    }
  ])

  const fullNameClassName = classNames([
    props.fullNameClassName,
    {
      'text-lg': ! props.size || props.size === 'small',
      'text-xl': props.size === 'medium',
      'text-2xl': props.size === 'big',
    }
  ])

  return (
    <div
      className={classNames(
        className,
        'transition-all group',
        { 'cursor-pointer': props.link },
      )}
      onClick={() => {
        if (props.link)
          history.push(props.link)
      }}
    >
      <AvatarImage
        user={user}
        size={props.size}
        edit={props.edit}
        className={classNames(
          props.imageClassName,
          { 'mb-2': ! props.horizontal },
        )}
      />
      <div>
        <h4
          className={classNames(
            fullNameClassName,
            'font-medium',
            { 'group-hover:underline': props.link },
          )}
        >{user.fullName}</h4>
        {
          props.withDescription &&
          <>
            {
              user.description &&
              <p>{user.description}</p>
            }
            {
              user.url &&
              <a className='text-blue-600 hover:underline' rel='noreferrer' target='_blank' href={user.url}>
                {user.url.replace(/https?:\/\//, '')}
              </a>
            }
          </>
        }
      </div>
    </div>
  )
}

Avatar.protoTypes = {
  className: propTypes.string,
  imageClassName: propTypes.string,
  user: propTypes.object.isRequired,
  horizontal: propTypes.bool,
  withDescription: propTypes.bool,
  edit: propTypes.bool,
  link: propTypes.string,
  size: propTypes.oneOf(['xsmall', 'small', 'medium', 'big']),
}
